// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__QeSr-","tabContainer":"styles_tabContainer__Qt1EL","tabContainerHighlight":"styles_tabContainerHighlight__nkU4r","tabItem":"styles_tabItem__MjpAh"};